import axios from "axios";
import { API_BASE_PATH, API_PATH, PATH } from "../utils/config";
import { v4 as uuidv4 } from "uuid"; // Importing uuid package

const getBaseUrl = () => {
  let baseUrl = API_BASE_PATH;
  if (
    typeof process !== "undefined" &&
    process?.env?.NODE_ENV === "development"
  ) {
    baseUrl = API_BASE_PATH;
  }
  return baseUrl;
};

const instance = axios.create({
  baseURL: getBaseUrl(),
});

const notLoginCall = (config) => {
  return config.url !== API_PATH.LOGIN;
};

instance.interceptors.request.use(
  (request) => {
    // console.log(request)
    if (!request.headers.Authorization) {
      const token = JSON.parse(localStorage.getItem("keyCloak") || "{}").token;
      if (token) {
        request.headers.Authorization = `Token ${token}`;
      }
    }

    //  Add TRANSACTION-ID header with a random number
    const transactionId = uuidv4(); // Generate a unique UUID
    request.headers["TRANSACTION-ID"] = transactionId;

    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
  { runWhen: notLoginCall }
);

instance.interceptors.response.use(
  (response) => {
    if (
      response?.config?.url === API_PATH.LOGIN ||
      response?.config?.url === API_PATH.GOOGLE_LOGIN ||
      response?.config?.url === API_PATH.FACEBOOK_LOGIN
    ) {
      let token = response?.data?.token;
      let user = response?.data?.user || JSON.parse(localStorage.getItem("keyCloak")).user;
      localStorage.setItem("keyCloak", JSON.stringify({ token, user }));
    }
    // console.log(response)
    return response;
  },
  (error) => {
    console.log("error", error);
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.detail === "Invalid token."
    ) {
      localStorage.removeItem("keyCloak");
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      const redirectParam = currentPath && currentPath !== "/" && currentPath !== PATH.LOGIN
        ? `?redirect=${encodeURIComponent(currentPath)}`
        : "";
      window.location.href = window.location.origin + PATH.LOGIN + redirectParam;
    }
    // error.response.status === 403 && error.response.data.detail === "CSRF Failed: CSRF token missing or incorrect."
    return Promise.reject(error);
  }
);

export default instance;
